import { Injectable } from '@angular/core';
import { CommonHttpService } from '@app/core/services/common-http.service';
import { Observable } from 'rxjs';
import * as io from 'socket.io-client';
import { environment } from '@environment/environment';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: SocketIOClient.Socket | null = null;
  private connected = false;
   constructor(private commonHttpService: CommonHttpService) { }
    private route = `user`

connect(userId: number): Promise<void> {
  return new Promise((resolve, reject) => {
    if (this.socket) {
      return resolve();
    }
    const baseUrl = environment.api_url.replace('/v1/api/', '');
  this.socket = io(`${baseUrl}/chat`, {
      query: { userId },
    transports: ['websocket'],
    forceNew: false,
    reconnection: true,
  });
    this.socket.on('connect', () => {
      this.connected = true;
      resolve();
    });
    this.socket.on('disconnect', () => {
      this.connected = false;
    });

    this.socket.on('connect_error', (err) => {
      reject(err);
    });
    });
  }
  onUserOnline(callback: (data: any) => void): void {
    this.socket.off('user-online');
    this.socket.on('user-online', (data) => {
      callback(data);
    });
  }
    onUserOffline(callback: (data: any) => void): void {
      this.socket.off('user-offline');
      this.socket.on('user-offline', (data) => {
        callback(data);
      });
    }
  public getOnlineUsers(): Observable<any> {
    return this.commonHttpService.get<any>(`${this.route}/online-users`);
  }

  // ================= JOIN ROOM =================
  joinRoom(channel: string): void {
    if (!this.socket || !this.connected) {
      return;
    }
    this.socket.emit('join-room', { channel });
  }

  // ================= SEND MESSAGE =================
  sendMessage(payload: any, ack?: (res: any) => void): void {
    if (!this.socket || !this.connected) {
      return;
    }
      this.socket.emit("send-message", payload, (response: any) => {
      if (ack) ack(response);
    });
  }

 public getmessages(argStaffId:any): Observable<any> {
      return this.commonHttpService.post<any, any>(`${this.route}/chat-messages`, argStaffId)
  }
  public createPrivateRoom(members: {
    memberOneId: number;
    memberTwoId: number;
  }): Observable<any> {
    return this.commonHttpService.post<any, any>(`${this.route}/create-private-room`, members);
  }

   public getListMessages(): Observable<any> {
      return this.commonHttpService.get<any>(`${this.route}/chats`)
  }

// ================= LISTEN NEW MESSAGE =================
onNewMessage(callback: (message: any) => void): void {
  if (!this.socket) return;
  this.socket.on('new-message', callback);
}

  onReadReceipt(callback: (data: any) => void): void {
    if (!this.socket) return;
    // this.socket.off('read-receipt');
    this.socket.on('read-receipt', callback);
  }

  sendReadReceipt(channel: string, messageId: number, company: string): void {
    if (!this.socket || !this.connected) return;
    this.socket.emit('message-read', {
      channel,
      messageId,
      company,
    });
  }

  chatMessageMarkAsRead(roomId: number, messageId: number) {
    return this.commonHttpService.post<any, any>(
      `${this.route}/chats/${roomId}/read?messageId=${messageId}`,
      {}  
    );
  }
searchMessages(payload: {
  roomId: number;
  keyword: string;
  pageNumber?: number;
  pageSize?: number;
}) {
  let params = new HttpParams()
    .set('roomId', payload.roomId.toString())
    .set('keyword', payload.keyword)
    .set('pageNumber', (payload.pageNumber ?? 1).toString())
    .set('pageSize', (payload.pageSize ?? 20).toString());

  return this.commonHttpService.get<any>(
    `${this.route}/chats/messages/search`,
    params
  );
}


  
  onMessageSeen(callback: (payload: {
      statusCode: number;
      message: string;
      data: { id: number; name: string }[];
    }) => void
  ) {
    if (!this.socket) return;

    this.socket.off("message-seen");
    this.socket.on("message-seen", callback);
  }
  editMessage(payload: {
    messageId: number;
    userId: number;
    newMessage: string;
  }, ack?: (res: any) => void): void {
    if (!this.socket) return;

    this.socket.emit('edit-message', payload, (response: any) => {
      if (ack) ack(response);
    });
  }

  onMessageEdited(callback: (message: any) => void): void {
    if (!this.socket) return;

    this.socket.off('message-edited');
    this.socket.on('message-edited', callback);
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }
  deleteMessage(messageId: number, userId: number) {
  if (!this.socket) return;

  this.socket.emit('delete-message', {
    messageId,
    userId,
  });
}

onMessageDeleted(callback: (data: { messageId: number }) => void) {
  if (!this.socket) return;
  this.socket.off('message-deleted');
  this.socket.on('message-deleted', callback);
}

getMessagesAround(payload: {
  roomId: number;
  messageId: number;
  pageSize?: number;
}) {
  let params = new HttpParams()
    .set('roomId', payload.roomId.toString())
    .set('messageId', payload.messageId.toString())
    .set('pageSize', (payload.pageSize ?? 20).toString());

     return this.commonHttpService.get<any>(
    `${this.route}/chats/messages/around`,
     params
  );
}

searchChatMembers(roomId: number, keyword: string): Observable<any> {
  let params = new HttpParams()
    .set('roomId', roomId.toString())
    .set('keyword', keyword);
  return this.commonHttpService.get<any>(`${this.route}/chat/room/search-members`, params);
}

downloadAttachment(key: string, fileName: string): Observable<any> {
  let params = new HttpParams()
    .set('key', key)
    .set('fileName', fileName);
  return this.commonHttpService.get<any>(`${this.route}/chat/download-attachment`, params);
}

addChatMember(payload: { roomId: number; targetUserId: number }): Observable<any> {
  return this.commonHttpService.post<any, any>(`${this.route}/chat/room/add-member`, payload);
}

removeChatMember(payload: { roomId: number; targetUserId: number }): Observable<any> {
  return this.commonHttpService.post<any, any>(`${this.route}/chat/room/remove-member`, payload);
}

// Socket listeners for real-time updates
onMemberAdded(callback: (data: any) => void): void {
  if (!this.socket) return;
  this.socket.off('member-added');
  this.socket.on('member-added', callback);
}

onMemberRemoved(callback: (data: any) => void): void {
  if (!this.socket) return;
  this.socket.off('member-removed');
  this.socket.on('member-removed', callback);
}

}